import React from 'react';
import './RecomendedScoreRadioButtons.scss';
interface RadioButtonProps {
  recommendedScoreValue: string;
  recommendedScoreText: string;
  selectedScore: string;
  radioButtonSize?: string;
  onChange: (...args: any[]) => any;
}
export default function RecomendedScoreRadioButtons({
  recommendedScoreValue,
  recommendedScoreText,
  selectedScore,
  radioButtonSize = '24',
  onChange,
}: RadioButtonProps) {
  const radioBtnoff = (
    <svg id='recommendedscoreradiobuttons-icon-off'
      width={radioButtonSize}
      height={radioButtonSize}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect 
        x="0.5"
        y="0.5"
        width={(parseInt(radioButtonSize) - 1).toString()}
        height={(parseInt(radioButtonSize) - 1).toString()}
        rx="11.5"
        fill="white"
        stroke="#303030"
      />
    </svg>
  );

  const radioBtnon = (
    <svg id='recommendedscoreradiobuttons-icon-on'
      width={radioButtonSize}
      height={radioButtonSize}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect 
        x="0.5"
        y="0.5"
        width={(parseInt(radioButtonSize) - 1).toString()}
        height={(parseInt(radioButtonSize) - 1).toString()}
        rx="11.5"
        fill="white"
        stroke="#303030"
      />

      <rect 
        x={((20.83333333333333 / 100) * parseInt(radioButtonSize)).toString()}
        y={((20.83333333333333 / 100) * parseInt(radioButtonSize)).toString()}
        width={((58.33333333333333 / 100) * parseInt(radioButtonSize)).toString()}
        height={((58.33333333333333 / 100) * parseInt(radioButtonSize)).toString()}
        rx="7"
        fill="#2F80ED"
      />
    </svg>
  );

  return (
    <div id={`recommendedscoreradiobuttons-wrapper-${recommendedScoreValue}`} className="score-group-main-div">
      <div
        id={recommendedScoreValue}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          onChange(recommendedScoreValue);
        }}
      >
        {selectedScore === recommendedScoreValue ? radioBtnon : radioBtnoff}
      </div>
      <div id={`recommendedscoreradiobuttons-radio-${recommendedScoreValue}`}
        style={{
          fontWeight: 400,
          display: 'flex',
          alignItems: 'center',
          marginLeft: '1%',
        }}
      >
        {recommendedScoreText}
      </div>
    </div>
  );
}
